import store from '../store/store';
import { database } from './firebase';

export const changeView = () =>{
    store.setState({
        actualPage: true,
    })
}

export const changeToSpanish = () => {
    store.setState({
        isSpanish: true,
    })
}

export const changeToEnglish = () => {
    store.setState({
        isSpanish: false,
    })
}

export const changeSection = () => {
    store.setState({
        actualPage: +1,
    })
}

export async function addMessage (name, email, message) {
    const messages = [...store.getState().messages]
    const newmessage = {
        username: name,
        email: email,
        message: message
    }

    const res = await database.ref('message/').push(newmessage);
    newmessage.id = res.key;

    const newMessage = messages.concat(newmessage);
    store.setState({
        messages: newMessage
    })

}

export const sendMessage = (name, email, message) => {
    console.log('message' + name + email + message);

    let newMessage = {
        username: name,
        email: email,
        message: message
    }
    database.ref('message/' + message.uid).set(newMessage); 
}



// WEBPACK FOOTER //
// ./src/actions/actions.js